type ResolutionCallStatus =
  | "idle"
  | "ringing"
  | "dialing"
  | "active"
  | "held"
  | "ended";

type ResolutionCallDirection = "incoming" | "outgoing" | undefined;

type ResolutionAnsweredCall = {
  uniqueId: string;
  isMine?: boolean;
};

type ResolutionSessionState = {
  callStatus: ResolutionCallStatus;
  callDirection?: ResolutionCallDirection;
  callUuid?: string | null;
  callId?: string | null;
  answeredCalls: ResolutionAnsweredCall[];
  activeSuperviseMode?: "listen" | "barge" | null;
};

function hadEstablishedCallSession(status: ResolutionCallStatus) {
  return status === "active" || status === "held";
}

export function isSuperviseCallSession(state: ResolutionSessionState) {
  if (state.activeSuperviseMode) return true;

  const correlator = state.callUuid?.trim() || state.callId?.trim() || null;
  if (!correlator) return false;

  return state.answeredCalls.some(
    (call) => call.uniqueId === correlator && call.isMine === false
  );
}

export function shouldOwnCallResolutionSession(state: ResolutionSessionState) {
  if (!hadEstablishedCallSession(state.callStatus)) return false;
  if (isSuperviseCallSession(state)) return false;
  if (state.callDirection === "outgoing") return true;

  const correlator = state.callUuid?.trim() || state.callId?.trim() || null;
  if (!correlator) return false;

  const matching = state.answeredCalls.find(
    (call) => call.uniqueId === correlator
  );
  if (matching?.isMine === true) return true;
  if (matching?.isMine === false) return false;

  return state.callDirection === "incoming";
}

export function shouldAutoOpenCallResolution(params: {
  previousCallStatus: ResolutionCallStatus;
  ownedCallSession: boolean;
  supervisedCallSession?: boolean;
}) {
  return (
    hadEstablishedCallSession(params.previousCallStatus) &&
    params.ownedCallSession &&
    !params.supervisedCallSession
  );
}
